<div class="modal-header">
   <h5 *ngIf="title" class="modal-title">{{ title }}</h5>
   <button type="button" class="btn-close close pull-right" (click)="modalRef.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
   </button>
</div>
<div class="modal-body">
   <div class="container">{{ jsonValue }}</div>
</div>
